// ** React Imports
import { useCallback, useEffect, useRef, useState } from 'react'
import { useDeviceScopedInit } from 'src/hooks/useDeviceScopedInit'
import { useExtremeUpgradeRefresh } from 'src/hooks/useExtremeUpgradeRefresh'

// ** MUI Imports
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

import { useTranslation } from 'src/utils/i18n'

import dayjs from 'dayjs'

// ** Store & Actions Imports
import { useDispatch, useSelector } from 'react-redux'
import { selectMessage, fetchUserProfile, fetchChatsContacts, removeSelectedChat } from 'src/store/apps/skype'

// ** Hooks
import { useSettings } from 'src/@core/hooks/useSettings'

// ** Utils Imports
import { getInitials } from 'src/@core/utils/get-initials'
import { formatDateToMonthShort } from 'src/@core/utils/format'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'

// ** Icon Imports
import Icon from 'src/@core/components/icon'

// ** Chat App Components Imports
import SkypeSideBar from 'src/@core/components/skype/skype-side-bar'
import SkypeContent from 'src/@core/components/skype/skype-content'
import SkypeTelephone from 'src/@core/components/skype/skype-call'
import SkypeContacts from 'src/@core/components/skype/skype-contacts'

import PerfectScrollbarComponent from 'react-perfect-scrollbar'

const PerfectScrollbar = styled(PerfectScrollbarComponent)(({ theme }) => ({
  padding: theme.spacing(5)
}))

// 通话/联系人示例数据（与 line / viber / facebook / tinder 等页保持一致）
const callData = {
  calls: [
    { id: 1, name: 'Aiden', img: '/images/avatars/1.png', icon: 'fluent:call-inbound-16-filled', time: 'Nov 11, 08:41 pm', Time: '19s', state: -1 },
    { id: 2, name: 'Jacob', img: '/images/avatars/2.png', icon: 'fluent:call-inbound-16-filled', time: 'Nov 11, 08:41 pm', Time: '19s', state: -1 },
    { id: 3, name: 'Ethan', img: '/images/avatars/3.png', icon: 'fluent:call-outbound-16-filled', time: 'Nov 11, 08:41 pm', Time: '40s', state: 1 },
    { id: 4, name: 'Caden', img: '/images/avatars/4.png', icon: 'fluent:call-inbound-16-filled', time: 'Nov 11, 08:41 pm', Time: '12s', state: -1 },
    { id: 5, name: 'Mia', img: '/images/avatars/5.png', icon: 'fluent:call-outbound-16-filled', time: 'Nov 10, 06:20 pm', Time: '1m 05s', state: 1 },
    { id: 6, name: 'Lucas', img: '/images/avatars/6.png', icon: 'fluent:call-inbound-16-filled', time: 'Nov 10, 09:03 am', Time: '8s', state: -1 }
  ],
  contacts: [
    { id: 1, name: 'Sarah', img: '/images/avatars/2.png' },
    { id: 2, name: 'Jacob', img: '/images/avatars/2.png' },
    { id: 3, name: 'Ethan', img: '/images/avatars/3.png' },
    { id: 4, name: 'Caden', img: '/images/avatars/4.png' },
    { id: 5, name: 'Mia', img: '/images/avatars/5.png' },
    { id: 6, name: 'Lucas', img: '/images/avatars/6.png' },
    { id: 7, name: 'Emma', img: '/images/avatars/7.png' },
    { id: 8, name: 'Noah', img: '/images/avatars/8.png' }
  ]
}

// component
import ChatCall from 'src/@core/components/common/chatCall'

import { getAllDashboard } from '/src/@api/dashboard'

import { Spin, Pagination } from 'antd'
import { setCurrentTab, changeExtremeService } from 'src/store/apps/Common'

import { generateMockData } from 'src/utils'
import { getUserAccountOrder } from 'src/@api/login'

const Skype = () => {
  const { t } = useTranslation('common')

  // ** States
  const [userStatus, setUserStatus] = useState('online')
  const [leftSidebarOpen, setLeftSidebarOpen] = useState(false)
  const [userProfileLeftOpen, setUserProfileLeftOpen] = useState(false)
  const [userProfileRightOpen, setUserProfileRightOpen] = useState(false)
  const [advanced, setAdvanced] = useState(true) // 是否购买高级服务

  const [fetchLoading, setFetchLoading] = useState(true) // 数据获取中

  // ** Hooks
  const theme = useTheme()
  const { settings } = useSettings()
  const dispatch = useDispatch()
  const hidden = useMediaQuery(theme.breakpoints.down('lg'))

  const store = useSelector(state => state.Skype)

  // ** Vars
  const { skin } = settings
  const smAbove = useMediaQuery(theme.breakpoints.up('sm'))
  const sidebarWidth = smAbove ? 370 : 300
  const mdAbove = useMediaQuery(theme.breakpoints.up('md'))

  const [chat, setChat] = useState(true)
  const [calls, setCalls] = useState(false)
  const [headImg, setHaedImg] = useState('/images/call-log/1.webp')

  const [contacts, setContacts] = useState(false)

  useEffect(() => {
    dispatch(fetchUserProfile())
    dispatch(fetchChatsContacts())
  }, [dispatch])
  const handleLeftSidebarToggle = () => setLeftSidebarOpen(prev => !prev)
  const handleUserProfileLeftSidebarToggle = () => setUserProfileLeftOpen(prev => !prev)
  const handleUserProfileRightSidebarToggle = () => setUserProfileRightOpen(prev => !prev)

  const [switchDataType, setSwitchDataType] = useState('activity')

  let selectSwitchDataStyle = {
    background: '#121444',
    color: '#fff',
    display: 'inline-block',
    width: '90px',
    height: '26px',
    lineHeight: '26px',
    fontSize: '18px',
    textAlign: 'center'
  }

  let switchDataStyle = {
    display: 'inline-block',
    width: '90px',
    height: '26px',
    lineHeight: '26px',
    fontSize: '18px',
    textAlign: 'center'
  }

  let [chatCallData, setChatCallData] = useState([])
  const [currentPage, setCurrentPage] = useState(1)

  const [total, setTotal] = useState(0)

  // 分页参数
  const [pagination, setPagination] = useState({
    reqNum: 50, // 单次查询数量
    nowOffset: 0, // 偏移量
    maxNum: false // 全部数据查询完毕
  })

  const getChatCallData = async nowOffset => {
    const username = JSON.parse(localStorage.getItem('DeviceUser')) != null
      ? JSON.parse(localStorage.getItem('DeviceUser')).username
      : ''

    // 获取最近的10笔订单
    let res = await getUserAccountOrder({ page: 1, pageSize: 10 })

    // 查找有限期最长的订单
    const lastOrder = res.data.sort((a, b) => dayjs(b.expire_time).valueOf() - dayjs(a.expire_time).valueOf())[0]

    // 计算是否为增值服务上线前付费用户

    // 增值服务上线前付费用户状态更新

    let data = await getAllDashboard({
      username,
      params: {
        category: 'SKYPE_INTERACTION',
        offset: nowOffset,
        limit: pagination.reqNum,
        deviceUdid:
          JSON.parse(localStorage.getItem('currentDevice')) != null
            ? JSON.parse(localStorage.getItem('currentDevice'))['Unique Identifier']
            : ''
      }
    })

    setTotal(data.data.totalCount)

    const advanced = username == null || !('advanced' in data) || ['true', true].includes(data?.advanced) // 高级服务开通状态
    setAdvanced(advanced)
    dispatch(changeExtremeService(advanced)) // 更新高级服务状态

    if (data.data.contents == null) {
      setPagination(page => ({ ...page, maxNum: true }))
      setFetchLoading(false)

      return
    }

    let result = data.data.contents.map(row => {
      return {
        ...row,
        date: dayjs(row.date).format('YYYY-MM-DD HH:mm:ss'),
        icon: 'prime:send',
        color: row.isFromMe ? '#585858' : '#D43538'
      }
    })

    if (!advanced) result = generateMockData(result)

    if (chatCallData.length > 0) setChatCallData(old => ([...old, ...result]))
    else setChatCallData(result)

    setFetchLoading(false)
  }

  // 设备切换时重置列表并重新拉数
  useDeviceScopedInit(
    useCallback(() => {
      setChatCallData([])
      setPagination({ reqNum: 50, nowOffset: 0, maxNum: false })
      setScroll(0)
      setCurrentPage(1)
      setTotal(0)
      setFetchLoading(true)
      getChatCallData(0)
    }, [])
  )

  // 升级成功后重拉本页数据（监听 extreme-upgraded，逻辑对齐 useDeviceScopedInit）
  useExtremeUpgradeRefresh(
    useCallback(() => {
      setAdvanced(true)
      setChatCallData([])
      setPagination({ reqNum: 50, nowOffset: 0, maxNum: false })
      setScroll(0)
      setCurrentPage(1)
      setTotal(0)
      setFetchLoading(true)
      getChatCallData(0)
    }, [])
  )

  const dom = useRef(null)

  // 滚动百分比
  const [scroll, setScroll] = useState(0)

  // 获取滚动百分比
  useEffect(() => {
    const handScroll = () => {
      if (dom.current) {
        const { scrollTop, scrollHeight, clientHeight } = dom.current
        const progress = scrollTop / (scrollHeight - clientHeight) * 100

        setScroll(progress.toFixed(0))
      }
    }

    const currentRef = dom.current
    if (currentRef) {
      currentRef.addEventListener('scroll', handScroll)
    }

    return () => {
      if (currentRef) {
        currentRef.removeEventListener('scroll', handScroll)
      }
    }
  }, [])

  // 监听滚动百分比
  useEffect(() => {
    if (scroll >= 100 && advanced) {
      const nowOffset = pagination.nowOffset + pagination.reqNum
      setPagination(page => ({ ...page, nowOffset }))

      if (!pagination.maxNum) getChatCallData(nowOffset)
    }
  }, [scroll])

  useEffect(() => {
    const title = t('Skype')
    dispatch(setCurrentTab(title))

    return () => dispatch(setCurrentTab(''))
  }, [dispatch, t])

  return (
    <>
      {/* <div
        style={{
          height: 'auto',
          width: '180px',
          boxShadow: '0px 2px 10px 0px rgba(76, 78, 100, 0.22)',
          borderRadius: '10px',
          marginBottom: '10px',
          overflow: 'hidden',
          cursor: 'pointer'
        }}
      >
        <span
          style={switchDataType == 'activity' ? selectSwitchDataStyle : switchDataStyle}
          onClick={() => setSwitchDataType('activity')}
        >
          ACTIVITY
        </span>
        <span
          style={switchDataType == 'chat' ? selectSwitchDataStyle : switchDataStyle}
          onClick={() => setSwitchDataType('chat')}
        >
          CHAT
        </span>
      </div> */}

      {switchDataType == 'activity' ? (
        <>
          <ChatCall dom={dom} data={chatCallData} advanced={advanced} fetchLoading={fetchLoading} />
          {/* <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row-reverse', marginTop: '20px' }}>
            <Pagination
              pageSizeOptions={[50]}
              total={total}
              pageSize={50}
              current={currentPage}
              color='primary'
              onChange={(page, pageSize) => setCurrentPage(page)}
            />
          </Box> */}
        </>
      ) : null}

      {switchDataType == 'chat' ? (
        <Box
          className='app-chat'
          sx={{
            width: '100%',
            minHeight: 'calc(var(--vh)*100 - 370px)',
            display: 'flex',
            borderRadius: 1,
            position: 'relative',
            boxShadow: skin === 'bordered' ? 0 : 6,
            ...(skin === 'bordered' && { border: `1px solid ${theme.palette.divider}` })
          }}
        >
          <SkypeSideBar
            store={store}
            hidden={hidden}
            mdAbove={mdAbove}
            dispatch={dispatch}
            userStatus={userStatus}
            selectMessage={selectMessage}
            getInitials={getInitials}
            sidebarWidth={sidebarWidth}
            setUserStatus={setUserStatus}
            leftSidebarOpen={leftSidebarOpen}
            removeSelectedChat={removeSelectedChat}
            userProfileLeftOpen={userProfileLeftOpen}
            formatDateToMonthShort={formatDateToMonthShort}
            handleLeftSidebarToggle={handleLeftSidebarToggle}
            handleUserProfileLeftSidebarToggle={handleUserProfileLeftSidebarToggle}
            calls={calls}
            setCalls={setCalls}
            chat={chat}
            contacts={contacts}
            headImg={headImg}
            setChat={setChat}
            setHaedImg={setHaedImg}
            setContacts={setContacts}
          />
          {chat && (
            <SkypeContent
              store={store}
              hidden={hidden}
              mdAbove={mdAbove}
              dispatch={dispatch}
              getInitials={getInitials}
              sidebarWidth={sidebarWidth}
              userProfileRightOpen={userProfileRightOpen}
              handleLeftSidebarToggle={handleLeftSidebarToggle}
              handleUserProfileRightSidebarToggle={handleUserProfileRightSidebarToggle}
              headImg={headImg}
              setHaedImg={setHaedImg}
            />
          )}

          {calls && (
            <SkypeTelephone
              store={store}
              hidden={hidden}
              mdAbove={mdAbove}
              dispatch={dispatch}
              getInitials={getInitials}
              sidebarWidth={sidebarWidth}
              userProfileRightOpen={userProfileRightOpen}
              handleLeftSidebarToggle={handleLeftSidebarToggle}
              handleUserProfileRightSidebarToggle={handleUserProfileRightSidebarToggle}
              setCalls={setCalls}
              headImg={headImg}
              setHaedImg={setHaedImg}
              callData={callData}
            />
          )}

          {contacts && (
            <SkypeContacts
              store={store}
              hidden={hidden}
              mdAbove={mdAbove}
              dispatch={dispatch}
              getInitials={getInitials}
              sidebarWidth={sidebarWidth}
              userProfileRightOpen={userProfileRightOpen}
              handleLeftSidebarToggle={handleLeftSidebarToggle}
              handleUserProfileRightSidebarToggle={handleUserProfileRightSidebarToggle}
              setCalls={setCalls}
              headImg={headImg}
              setHaedImg={setHaedImg}
              setContacts={setContacts}
              callData={callData}
            />
          )}
        </Box>
      ) : null}
    </>
  )
}

Skype.contentHeightFixed = true

export default Skype


